// @flow

import ArrowDown from './arrow-down.svg';
import Account from './account.svg';
import Key from './key.svg';
import LightBulb from './light-bulb.svg';
import Shield from './shield.svg';
import Bolt from './bolt.svg';

const Flags = {
    ArrowDown: {
        Path: ArrowDown,
        Alt: 'Arrow'
    },
    Account: {
        Path: Account,
        Alt: 'Account'
    },
    Key: {
        Path: Key,
        Alt: 'Key'
    },
    LightBulb: {
        Path: LightBulb,
        Alt: 'Light Bulb'
    },
    Shield: {
        Path: Shield,
        Alt: 'Shield'
    },
    Bolt: {
        Path: Bolt,
        Alt: 'Bolt'
    }
};

export default Flags;
